module.exports = __webpack_public_path__ + "media/images/icons/help-20cd8c0b6b0becb865972253bd5272a8.svg";